import { Box, makeStyles } from "@material-ui/core";
import React from "react";

import { layoutTokens } from "@/designTokens";

import { HomeSectionKey } from "../utils/homeSectionOrder";

const useStyles = makeStyles(() => ({
  firstFollowingSection: { marginTop: -layoutTokens.space[16] },
}));

interface Props {
  styleDiagnosis: React.ReactNode;
  sections: { key: HomeSectionKey; node: React.ReactNode }[];
}

// 親の sectionStack は gap=32。診断ミニ表示と最初のセクション（相性の良いプランナー）の間だけ16にする。
// 全セクションの親と key を固定し、取得後の挿入・並び替えでもバナー等を再マウントしない。
export const HomeMobileSections: React.FC<Props> = ({ styleDiagnosis, sections }) => {
  const classes = useStyles();
  return <>
    {styleDiagnosis}
    {sections.map(({ key, node }, index) => (
      <Box key={key} className={index === 0 && styleDiagnosis ? classes.firstFollowingSection : undefined}>{node}</Box>
    ))}
  </>;
};
